module.exports = __webpack_public_path__ + "static/media/淘宝2_03.be786405.jpg";